import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { DEFAULT_LOCALE } from "~constants";
import type { PageData } from "~types/types";
import { PublishedState } from "~types/wardenclyffe";

const initialState: PageData = {
    adCode: "",
    locale: DEFAULT_LOCALE,
    preview: false,
    pageNumber: 0,
    shouldPaginate: false,
    previousPage: 0,
    pageId: "",
    publishedState: PublishedState.Published,
    title: "",
    pageType: "",
    description: "",
    brand: "business",
    path: "",
};

const pageDataSlice = createSlice({
    name: "pageData",
    initialState,
    reducers: {
        pageDataFetched(state, action: PayloadAction<PageData>) {
            Object.assign(state, action.payload);
        },
    },
});

export const { pageDataFetched } = pageDataSlice.actions;

export default pageDataSlice.reducer;
